import React, { useState, useEffect } from 'react';

const MobileNavlink = ({ setIsMobileMenuOpen }) => {
    const [activeLink, setActiveLink] = useState('');

    // Track the active link on hash change
    useEffect(() => {
        setActiveLink(window.location.hash);

        const handleHashChange = () => {
            setActiveLink(window.location.hash);
        };

        window.addEventListener('hashchange', handleHashChange);

        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);

    // Function to handle click and update the active link
    const handleLinkClick = (link) => {
        setActiveLink(link);  // Update active link
        window.location.hash = link;  // Update the URL hash to navigate
        setIsMobileMenuOpen(false);
    };

    return (
        <div className="d-flex align-items-center justify-content-center bg-primary text-white" style={{ height: '100vh' }}>
            <ul className="list-unstyled text-center">
                <li className="mb-4">
                    <a
                        href="#product"
                        onClick={() => handleLinkClick('#product')}
                        className={`nav-link text-white ${activeLink === '#product' ? 'fw-bold active-link' : ''}`}
                    >
                        Product
                    </a>
                </li>
                <li className="mb-4">
                    <a
                        href="#casestudies"
                        onClick={() => handleLinkClick('#casestudies')}
                        className={`nav-link text-white ${activeLink === '#casestudies' ? 'fw-bold active-link' : ''}`}
                    >
                        Case Studies
                    </a>
                </li>
                <li className="mb-4">
                    <a
                        href="#testimonial"
                        onClick={() => handleLinkClick('#testimonial')}
                        className={`nav-link text-white ${activeLink === '#testimonial' ? 'fw-bold active-link' : ''}`}
                    >
                        Testimonial
                    </a>
                </li>
                <li className="mb-4">
                    <a
                        href="#clients"
                        onClick={() => handleLinkClick('#clients')}
                        className={`nav-link text-white ${activeLink === '#clients' ? 'fw-bold active-link' : ''}`}
                    >
                        Clients
                    </a>
                </li>
                <li className="mb-4">
                    <a
                        href="#about"
                        onClick={() => handleLinkClick('#about')}
                        className={`nav-link text-white ${activeLink === '#about' ? 'fw-bold active-link' : ''}`}
                    >
                        About Us
                    </a>
                </li>
                <li className="mb-4">
                    <a
                        href="#contact"
                        onClick={() => handleLinkClick('#contact')}
                        className={`nav-link text-white ${activeLink === '#contact' ? 'fw-bold active-link' : ''}`}
                    >
                        Contact
                    </a>
                </li>
                <li>
                    <a
                        className="btn btn-warning text-dark px-4 py-2 rounded-pill fw-bold"
                        href="#product"
                        onClick={() => handleLinkClick('#product')}
                    >
                        Get Started
                    </a>
                </li>
            </ul>
        </div>
    );
};

export default MobileNavlink;
